import React, { useState, useEffect } from 'react';
import { auth } from '../firebase';
import { signInWithEmailAndPassword, signOut, onAuthStateChanged } from 'firebase/auth';

const AuthComponent = ({ onAuthChange }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setUser(user);
      onAuthChange(user);
    });

    return () => unsubscribe();
  }, [onAuthChange]);

  const handleSignIn = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      await signInWithEmailAndPassword(auth, email, password);
      console.log('Signed in successfully');
    } catch (error) {
      console.error('Sign in error:', error);
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleSignOut = async () => {
    try {
      await signOut(auth);
      console.log('Signed out successfully');
    } catch (error) {
      console.error('Sign out error:', error);
    }
  };

  if (user) {
    return (
      <div className="auth-status bg-green-800 rounded-lg p-4 mb-6 border border-green-600">
        <div className="flex items-center justify-between">
          <div>
            <h3 className="text-green-200 font-semibold">✅ Signed In</h3>
            <p className="text-green-300 text-sm">Email: {user.email}</p>
            <p className="text-green-300 text-sm">UID: {user.uid}</p>
          </div>
          <button
            onClick={handleSignOut}
            className="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded transition-colors"
          >
            Sign Out
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-form bg-gray-800 rounded-lg p-6 mb-6 border border-gray-700">
      <h3 className="text-white font-semibold mb-4">🔐 Authentication Required</h3>
      
      <form onSubmit={handleSignIn} className="space-y-3 md:space-y-4">
        <div>
          <label className="block text-gray-300 text-xs md:text-sm mb-2">Email:</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full px-3 py-3 md:py-2 bg-gray-700 text-white border border-gray-600 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm md:text-base"
            placeholder="Enter your email"
            required
          />
        </div>
        
        <div>
          <label className="block text-gray-300 text-xs md:text-sm mb-2">Password:</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full px-3 py-3 md:py-2 bg-gray-700 text-white border border-gray-600 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm md:text-base"
            placeholder="Enter your password"
            required
          />
        </div>
        
        {error && (
          <div className="bg-red-800 border border-red-600 text-red-200 px-3 py-2 rounded text-sm">
            {error}
          </div>
        )}
        
        <button
          type="submit"
          disabled={loading}
          className="w-full bg-blue-600 hover:bg-blue-700 text-white py-2 px-4 rounded transition-colors disabled:opacity-50"
        >
          {loading ? 'Signing In...' : 'Sign In'}
        </button>
      </form>
      
    </div>
  );
};

export default AuthComponent;










